import { endRoute, parentRoute } from '$shared/utils/routes';

export const onboardingRoutes = {
  unauthOnboarding: endRoute(`${process.env.NEXT_GEN_PROXY_URL}/get-started`),
  authOnboarding: parentRoute('/postonboarding')({
    childInfo: endRoute('/postonboarding/child-info'),
    worryDomains: endRoute('/postonboarding/worry-domains'),
  }),
};
